import {EventFilterCodes, EventFiltersValuesJoinType, EVENTS_FILTERS_CONFIG} from 'modules/events/constants';
import {IEventFilter} from 'modules/events/types';
import {ICity} from 'modules/locations/models';

const FILTER_API_KEY = 'filter';

const setDateQuery = (filter: IEventFilter): string => {
    const [day, month, year] = filter.values[0].split('.');
    const formattedDate = `${year}-${month}-${day}`;
    return `${FILTER_API_KEY}[${filter.code}]=${formattedDate}`;
};

const setOrQuery = (filter: IEventFilter): string[] => {
    return filter.values.map((value) => `${FILTER_API_KEY}[${filter.code}][]=${value}`);
};

const setSingleQuery = (filter: IEventFilter): string => {
    return `${FILTER_API_KEY}[${filter.code}]=${filter.values[0]}`;
};

const processFilter = (filter: IEventFilter): string[] => {
    if (EventFilterCodes.date === filter.code) {
        return [setDateQuery(filter)];
    }

    if (filter.valuesJoinType === EventFiltersValuesJoinType.OR) {
        return setOrQuery(filter);
    }

    return [setSingleQuery(filter)];
};

export const convertFiltersToQuery = (filters: IEventFilter[], cityCode?: ICity['code']): string => {
    const queryArray = filters.flatMap(processFilter);

    if (cityCode) {
        queryArray.push(`filter[city]=${cityCode}`);
    }

    if (!queryArray.length) {
        return '';
    }

    return `?${queryArray.join('&')}`;
};

export const parseEventsFiltersFromUrl = (url: string): IEventFilter[] => {
    const query = url.split('?')[1] ?? '';
    if (!query) {
        return [];
    }

    const searchParams = new URLSearchParams(query);
    const filters: IEventFilter[] = [];

    EVENTS_FILTERS_CONFIG.forEach(({code, valuesJoinType}) => {
        const stringValue = searchParams.get(code);
        if (!stringValue) {
            return;
        }

        let values: string[] = [stringValue];

        if (valuesJoinType === EventFiltersValuesJoinType.OR) {
            values = stringValue
                .split(
                    new RegExp(
                        `-${EventFiltersValuesJoinType.OR}-|-${EventFiltersValuesJoinType.OR.toUpperCase()}-`,
                        'iu',
                    ),
                )
                .filter((value) => value.trim());
        }

        filters.push({
            code,
            values,
            valuesJoinType,
        });
    });

    return filters;
};
